// Login / signup screen. Shown when GET /api/auth/me says nobody is signed
// in; on success it reloads the page so the dashboard boots fresh with a live
// session (simpler and less bug-prone than re-running init() by hand). Kept in
// the same vanilla style as the rest of the client.
import { $, esc, postStatus } from './core';

// One form, two modes. Signup adds a name field and hits a different endpoint;
// everything else — layout, error handling, the reload on success — is shared.
export function renderAuthGate(mode) {
  var m = mode === 'signup' ? 'signup' : 'login';
  var gate = $('#auth-gate');
  gate.innerHTML =
    '<div class="auth-card">' +
      '<div class="auth-brand">tuneloop</div>' +
      '<div class="auth-title">' + (m === 'signup' ? 'Create your account' : 'Sign in') + '</div>' +
      '<form id="auth-form" class="auth-form" autocomplete="on">' +
        (m === 'signup'
          ? '<label class="auth-lbl">Name<input class="auth-in" id="auth-name" type="text" autocomplete="name" /></label>'
          : '') +
        '<label class="auth-lbl">Email<input class="auth-in" id="auth-email" type="email" autocomplete="username" required /></label>' +
        '<label class="auth-lbl">Password<input class="auth-in" id="auth-pass" type="password" autocomplete="' +
          (m === 'signup' ? 'new-password' : 'current-password') + '" required /></label>' +
        '<div class="auth-err" id="auth-err"></div>' +
        '<button class="auth-btn" type="submit">' + (m === 'signup' ? 'Sign up' : 'Sign in') + '</button>' +
      '</form>' +
      '<div class="auth-switch">' +
        (m === 'signup'
          ? 'Already have an account? <a href="#" id="auth-toggle">Sign in</a>'
          : 'No account yet? <a href="#" id="auth-toggle">Sign up</a>') +
      '</div>' +
    '</div>';
  gate.classList.add('on');

  $('#auth-toggle').onclick = function (e) { e.preventDefault(); renderAuthGate(m === 'signup' ? 'login' : 'signup'); };
  $('#auth-form').onsubmit = function (e) { e.preventDefault(); submit(m); };
  var first = document.getElementById(m === 'signup' ? 'auth-name' : 'auth-email');
  if (first) first.focus();
}

function submit(mode) {
  var errEl = $('#auth-err');
  errEl.textContent = '';
  var email = ($('#auth-email').value || '').trim();
  var password = $('#auth-pass').value || '';
  var nameEl = document.getElementById('auth-name') as HTMLInputElement | null;
  var name = nameEl ? (nameEl.value || '').trim() : undefined;

  var btn = document.querySelector('#auth-form .auth-btn') as HTMLButtonElement | null;
  if (btn) { btn.disabled = true; btn.textContent = '…'; }
  var reset = function () { if (btn) { btn.disabled = false; btn.textContent = mode === 'signup' ? 'Sign up' : 'Sign in'; } };

  var url = mode === 'signup' ? '/api/auth/signup' : '/api/auth/login';
  postStatus(url, mode === 'signup' ? { email: email, password: password, name: name } : { email: email, password: password })
    .then(function (r) {
      // 2xx → the session cookie is set; reload into the authenticated app.
      if (r.status >= 200 && r.status < 300) { window.location.reload(); return; }
      reset();
      errEl.textContent = (r.body && r.body.error) || 'Something went wrong. Please try again.';
    })
    .catch(function () { reset(); errEl.textContent = 'Network error. Please try again.'; });
}
